import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Integration } from "../models";
import { integrationService } from "../services";
import { handlePromiseError } from "../helpers/api";
import { useCallback } from "react";

/**
 * useConnectionSettings initializes and manages the connection settings integration.
 *
 * @param {Object} param0 - An object containing parameters.
 * @param {Object} param0.integration - The integration configuration data.
 * @returns {Object} Returns an object with connection settings related methods.
 */
const useConnectionSettings = ({ integration }) => {
  const queryClient = useQueryClient();
  const { mutateAsync: updateIntegration } = useMutation({
    mutationFn: async (updatedIntegration: Integration) => {
      return integrationService
        .updateSingle(updatedIntegration.id, updatedIntegration)
        .then(handlePromiseError);
    },
    onSuccess: (response) => {
      queryClient.setQueryData(["integration", integration.id], response);
    },
  });

  const connectionSubmitHandler = useCallback(
    async (values) => {
      if (integration?.id) {
        await updateIntegration({
          id: integration.id,
          connectionId: values.connectionId,
        });
      }
    },
    [integration?.id, updateIntegration],
  );

  return {
    connectionSubmitHandler,
  };
};

export default useConnectionSettings;
